import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import InteligenciaArtificial from "../pages/inteligencia-artificial/page";
import AgentesIa from "../pages/agentes-ia/page";
import DesarrolloSoftware from "../pages/desarrollo-software/page";
import Integraciones from "../pages/integraciones/page";
import SapBusinessOne from "../pages/sap-business-one/page";
import Arquitectura from "../pages/arquitectura/page";
import Soluciones from "../pages/soluciones/page";
import Proyectos from "../pages/proyectos/page";
import Nosotros from "../pages/nosotros/page";
import Contacto from "../pages/contacto/page";
import Privacidad from "../pages/legal/Privacidad";
import Terminos from "../pages/legal/Terminos";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/inteligencia-artificial", element: <InteligenciaArtificial /> },
  { path: "/agentes-ia", element: <AgentesIa /> },
  { path: "/desarrollo-software", element: <DesarrolloSoftware /> },
  { path: "/integraciones", element: <Integraciones /> },
  { path: "/sap-business-one", element: <SapBusinessOne /> },
  { path: "/arquitectura", element: <Arquitectura /> },
  { path: "/soluciones", element: <Soluciones /> },
  { path: "/proyectos", element: <Proyectos /> },
  { path: "/nosotros", element: <Nosotros /> },
  { path: "/contacto", element: <Contacto /> },
  { path: "/privacidad", element: <Privacidad /> },
  { path: "/terminos", element: <Terminos /> },
  { path: "*", element: <NotFound /> },
];

export default routes;